export const DAYS_FOR_DOCTOR_SLOTS = 30 as const
